import * as _ from 'lodash';

import { Table } from './table';

import { TableSettings, TableRemoteParams, TableRemotePagination, TableRemoteFilter, TableRemoteOnChange, TableRemoteModel } from '../table.interface';

export class TableRemote {
  constructor(
    private _tableSettings: TableSettings,
    private _table: Table
  ) {
    if (!this._tableSettings.remote) { this._tableSettings.remote = {}; }
  }

  public error = false;

  public call(): Promise<Array<any>> {
    this.error = false;
    return new Promise((resolve, reject) => {
      this.model.method(this.params)
        .then((response) => {
          this._table.setPagination(response.data.meta.page, true);
          const data: Array<any> = (<any>_.at(response.data, this.model.accessor))[0];
          resolve(data);
          if (this.onChange) { this.onChange(response); }
        })
        .catch((err) => {
          this.error = true;
          reject(err);
        });
    });
  }

  public get initial_loading(): boolean {
    return this.valid ? (_.isBoolean(this._tableSettings.remote.initial_loading) ? this._tableSettings.remote.initial_loading : true) : false;
  }

  public get model(): TableRemoteModel {
    return this.valid ? this._tableSettings.remote.model : null;
  }

  public setModel(model: TableRemoteModel, skip_update: boolean = false) {
    this._tableSettings.remote.model = model;
    if (!skip_update) { this._table.update(); }
  }

  public get params(): TableRemoteParams {
    if (!this.valid) { return {}; }
    const params = this._tableSettings.remote.params ? _.cloneDeep(this._tableSettings.remote.params) : {};
    if (!this._tableSettings.pagination.disabled) {
      params.page = {
        size: this.pagination.size,
        number: this.pagination.number
      };
    }
    params.filter = this.filter;
    params.sort = this.sort;
    return params;
  }

  public setParams(params: TableRemoteParams, skip_update: boolean = false) {
    this._tableSettings.remote.params = params;
    if (!skip_update) { this._table.update(); }
  }

  public get sort(): string {
    return this._table.sort.direction === 'asc' ? this._table.sort.accessor : `-${this._table.sort.accessor}`;
  }

  public get filter(): TableRemoteFilter {
    return this._table.filter;
  }

  public get pagination(): TableRemotePagination {
    return this._table.pagination;
  }

  public get valid(): boolean {
    const remote = this._tableSettings.remote;
    return (remote && remote.model && remote.model.method && remote.model.method) ? true : false;
  }

  public get onChange(): TableRemoteOnChange {
    if (this.valid && _.isFunction(this._tableSettings.remote.onChange)) { return this._tableSettings.remote.onChange; }
    return;
  }
}
